import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IPageComponent } from '~Interfaces/ipagecomponent';

import { UtilisateurService } from '~Services/utilisateur.service';
import { Constantes } from '~Tools/Constantes';

/**
 * Composant fiche
 * @extends IPageComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-fiche',
  templateUrl: './fiche.component.html',
  styleUrls: ['./fiche.component.scss']
})
export class FicheComponent extends IPageComponent implements OnInit {
    indexFournisseur: number = 0;
    codeFournisseur: string = '';

    listeFournisseurs: any[] = [];

    listeCampagnes: any[] = [];

    SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };

    afficherBoutonOngletsGauche: boolean = false;
    afficherBoutonOngletsDroite: boolean = false;
    afficherBoutonsOnglets: boolean = false;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.verificationBoutonsOnglets();
    }

    /**
     * Constructeur
     * @param utilisateurService
     */
    constructor(@Inject(UtilisateurService) private utilisateurService: UtilisateurService, private route: ActivatedRoute) { super() }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        // R�cup�ration du code fournisseur
        if (!this.codeFournisseur) {
            this.codeFournisseur = this.route.snapshot.queryParams['code'];
        }

        this.utilisateurService.obtenirCampagnesActives().subscribe((retour: any) => {
            this.listeCampagnes = retour.Result;
        })

        // R�cup�ration des fournisseurs de l'utilisateur
        this.utilisateurService.obtenirUtilisateurCourant().subscribe((retour: any) => {
            if (retour && retour.Result) {
                this.definirListeFournisseur(retour.Result.ListeFournisseurs);
                if (!this.codeFournisseur) {
                    this.codeFournisseur = retour.Result.CodeFournisseur;
                }
            }
        });
    }

    /**
     * D�finir le liste des fournisseurs
     * @param liste
     */
    definirListeFournisseur(liste) {
        // D�finit la liste des fournisseurs
        this.listeFournisseurs = this.filtrerListeFournisseur(liste);
        // Onglets = liste des fournisseurs : V�rification des boutons des onglets
        setTimeout(() => { this.verificationBoutonsOnglets(); }, 10);
    }

    /**
     * Ev�nement fournisseur
     * @param fournisseur
     */
    fournisseurEvent(fournisseur) {
        if (fournisseur) {
            let code = fournisseur.Code;
            let libelle = fournisseur.RaisonSociale;
            if (code && libelle) {
                // R�cup�re le fournisseur de l'onglet correspondant
                let fournisseurOnglet = this.obtenirFournisseur(code);
                if (fournisseurOnglet) {
                    // Mettre � jour l'onglet fournisseur
                    fournisseurOnglet.Libelle = libelle;
                }
            }
        }
    }

    /**
     * S�lectionner le fournisseur
     * @param codeFournisseur
     */
    selectionnerFournisseur(codeFournisseur) {
        if (this.estAutorisePourAffichage(codeFournisseur)) {
            this.codeFournisseur = codeFournisseur;
        }
    }

    /**
     * Swipe
     * @param action
     */
    swipe(action = this.SWIPE_ACTION.RIGHT) {
        // Ne pas effectuer le swipe si une popup est ouverte
        if (this.popupOuverte()) {
            return;
        }

        // Action
        if (action === this.SWIPE_ACTION.LEFT) {
            this.indexFournisseur++;
        }
        else if (action === this.SWIPE_ACTION.RIGHT) {
            this.indexFournisseur--;
        }

        // V�rification de l'index
        if (this.indexFournisseur >= this.listeFournisseurs.length) {
            this.indexFournisseur = 0;
        }
        else if (this.indexFournisseur < 0) {
            this.indexFournisseur = this.listeFournisseurs.length - 1;
        }

        // Changement de fournisseur
        this.codeFournisseur = this.listeFournisseurs[this.indexFournisseur].Code;
    }

    /**
     * Scroll des onglets � gauche
     */
    scrollGauche() {
        document.querySelector('.onglets ul').scrollLeft -= document.querySelector('.onglets ul').clientWidth;
        this.verificationBoutonsOnglets();
    }

    /**
     * Scroll des onglets � droite
     */
    scrollDroite() {
        document.querySelector('.onglets ul').scrollLeft += document.querySelector('.onglets ul').clientWidth;
        this.verificationBoutonsOnglets();
    }

    /**
     * V�rification de l'affichage des boutons des onglets
     */
    private verificationBoutonsOnglets() {
        if (document.querySelector('.onglets ul') != null) {
            this.verificationAffichageBoutonsOnglets();
            this.verificationAffichageBoutonOngletsDroite();
            this.verificationAffichageBoutonOngletsGauche();
        }
    }

    /**
     * V�rification pour afficher les boutons gauche/droite des onglets
     */
    private verificationAffichageBoutonsOnglets() {
        this.afficherBoutonsOnglets = document.querySelector('.onglets ul').scrollWidth > document.querySelector('.onglets ul').clientWidth;
    }

    /**
     * V�rification pour afficher le bouton droite des onglets
     */
    private verificationAffichageBoutonOngletsDroite() {
        this.afficherBoutonOngletsDroite = (document.querySelector('.onglets ul').scrollLeft + document.querySelector('.onglets ul').clientWidth) != document.querySelector('.onglets ul').scrollWidth;
    }

    /**
     * V�rification pour afficher le bouton gauche des onglets
     */
    private verificationAffichageBoutonOngletsGauche() {
        this.afficherBoutonOngletsGauche = document.querySelector('.onglets ul').scrollLeft != 0;
    }

    /**
     * Indique si le fournisseur est autoris� pour l'affichage
     * @param codeFournisseur
     */
    private estAutorisePourAffichage(codeFournisseur) {
        let fournisseur = this.obtenirFournisseur(codeFournisseur);
        if (fournisseur) {
            return fournisseur.CategorieFournisseurCode == Constantes.CATEGORIE_POINT_RELAIS;
        }
        return false;
    }

    /**
     * Obtenir un fournisseur par son code
     * @param codeFournisseur
     */
    private obtenirFournisseur(codeFournisseur: string) {
        if (this.listeFournisseurs && this.listeFournisseurs.length) {
            return this.listeFournisseurs.find((f) => {
                return f.Code == codeFournisseur;
            }); 
        }
        return null;
    }

    /**
     * Filtrer la liste des fournisseurs
     * @param listeFournisseur
     */
    private filtrerListeFournisseur(listeFournisseur): any[] {
        if (listeFournisseur && listeFournisseur.length) {
            // Liste uniquement les founisseurs point relais
            var listeFournisseurs = listeFournisseur as any[];
            listeFournisseurs = listeFournisseurs.filter((f) => {
                return f.CategorieFournisseurCode == Constantes.CATEGORIE_POINT_RELAIS;
            });
            return listeFournisseurs;
        }
        return [];
    }

    /**
     * Indique si une popup est ouverte
     */
    private popupOuverte(): boolean {
        // Liste les popups
        let popups = document.getElementsByClassName('pop-up');

        // Pour chaque popup
        for (let i = 0; i < popups.length; i++) {
            let popup = popups[i];

            // Si la popup est ouverte
            if (popup.className.indexOf('d-none') < 0) {
                return true;
            }
        }

        // Pas de popup ouverte
        return false;
    }
}
